import React, { Component } from 'react';
import ReconciliationExecute from './components/recon-execute';
import ReconciliationResults from './components/recon-results';
import ErrorBoundary from '../../components/error-boundary';
import Snackbar from '@material-ui/core/Snackbar';
import Banner from '../../components/banner';
import {connect} from 'react-redux';
import io from 'socket.io-client';
import {
      loadRecon,
      loadSelectedReconSummary,
      loadSelectedReconResults,
      loadSelectedReconExceptions,
      loadReconList,
      reloadReconList,
      clearAllData
    } from './recon.actions';

import {
          loadRuleSet
        } from '../../common-redux/common.actions';

let socket;

class Reconciliation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      appContentContainer:"app-content-container",
      reconQuestionsClass: "page-content select-container in",
      reconResultsClass: "page-content results-container",
      pageNavContainer:"hide",
      ruleListValue:"",
      step1:"",
      step2:"hide",
      reconSelectedRecord:"",
      snackbarStatus: false,
      bannerType: "danger",
      showBanner: false
    };

      // socket = io("http://localhost:5000/comparizone", {transports: ['websocket']});
      // /comparizone authenticates at the namespace level, so a tokenless handshake was
      // rejected and this page received nothing. Callback form, not a static object: it is
      // re-evaluated on every reconnect, so a rotated or refreshed token is picked up instead
      // of replaying the one captured at construction.
      socket = io('/comparizone', {
        transports: ['websocket'],
        auth: (cb) => cb({token: localStorage.getItem('access_token')}),
      });
      this.props.getRuleSetListItems();
      this.props.getReconListItems();
  }


  componentDidMount(){

    socket.on('connect', (value) => {
      socket.emit('reloadReconlist', { customId: localStorage.getItem('access_token') });
    });

    socket.on('reloadReconlist', (value) => {
        this.props.reloadReconItems(value);
    });

    socket.on('disconnect', function(){
      socket.disconnect();
    });
  }

  componentWillUnmount(){
    clearTimeout(this.bannerTimer);
    socket.disconnect();
    this.props.clearAllData();
  }

  componentDidUpdate(prevProps) {
  if (this.props.error !== prevProps.error) {
    this.setState({showBanner:true});
    // ponytail: auto-dismiss so one transient recon failure (e.g. opening a run that
    // errored) doesn't latch a generic "refresh the page" banner over a working page.
    clearTimeout(this.bannerTimer);
    this.bannerTimer = setTimeout(() => this.setState({showBanner:false}), 8000);
  }
}


  goToTop=()=>{
    document.getElementById("app").scrollTo(0,0);
  }

  dropdownSelector = (name,id,value) => {
              this.setState({[name]:value});
          }

  dismissBanner = () => {
                this.setState({showBanner:false});
         }

 snackHandler = (state) =>{
   this.setState({snackbarStatus:state});
 }

  selectRecon = (data) => {
                    this.setState({
                      appContentContainer:"app-content-container in",
                      reconQuestionsClass: "page-content select-container",
                      reconResultsClass: "page-content results-container in",
                      pageNavContainer:"page-nav-container",
                      filterValue:"all",
                      reconSelectedRecord:data
                    });
                    this.props.getReconItems(data);
                    //this.props.getReconSummary(data);
                    //this.props.getReconResults(data);

                    this.goToTop();
                }


 getReconExceptionData = () =>{
      this.props.getReconExceptions(this.state.reconSelectedRecord)
    }

  goBack = (level) => {
                    if(level===0){
                      this.setState({
                        appContentContainer:"app-content-container",
                        reconQuestionsClass: "page-content select-container in",
                        reconResultsClass: "page-content results-container",
                        pageNavContainer:"hide"
                      });
                    } else if (level===1){
                      this.setState({
                        pageNavContainer:"page-nav-container"
                      });
                    } else if (level===2){
                      this.setState({
                        pageNavContainer:"hide"
                      });
                    }
                }


   render() {


     return (
       <div className={this.state.appContentContainer}>

       <Snackbar
           open={this.state.snackbarStatus}
           message="Please wait..."
           className="snack-bar"
         />



          <div className={this.state.pageNavContainer}>
            <a onClick={this.goBack.bind(this,0)} className="back-link">
              <i className="material-icons">arrow_back</i>
              Back
            </a>
          </div>


       <Banner
          type={this.state.bannerType}
          hasAlerts={this.state.showBanner}
          header="Something went wrong."
          body="Please refresh the page and try again."
          dismissBanner={this.dismissBanner.bind(this)}
          />

        <div id='' className={this.state.reconQuestionsClass}>
          <h2>CompariZone</h2>
            <ReconciliationExecute
            onClick={this.selectRecon.bind(this)}
            ruleSetList={this.props.ruleSetList}
            reconList={this.props.reconList}
            />
        </div>

        <div id='' className={this.state.reconResultsClass}>
          <ErrorBoundary>
          <ReconciliationResults
            reconSelectedRecord={this.state.reconSelectedRecord}
            snackHandler={this.snackHandler.bind(this)}
            pageNavContainer={this.state.pageNavContainer}
            getReconExceptions={this.getReconExceptionData.bind(this)}
            parentNavBar={this.goBack.bind(this)}
            />
          </ErrorBoundary>
        </div>

       </div>
     );
   }
}

const mapStateToProps = (state) => {
  return{
    error: state.reconReducer.error,
    ruleSetList: state.commonReducer.ruleSetList,
    reconList: state.reconReducer.reconList,
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    getReconItems : (filename) => {
      dispatch(loadRecon(filename));
    },
    getReconSummary : (filename) => {
      dispatch(loadSelectedReconSummary(filename));
    },
    getReconResults : (filename) => {
      dispatch(loadSelectedReconResults(filename));
    },
    getReconExceptions : (filename) => {
      dispatch(loadSelectedReconExceptions(filename));
    },
    reloadReconItems : (json) => {
      dispatch(reloadReconList(json));
    },
    getReconListItems : () => {
      dispatch(loadReconList());
    },
    getRuleSetListItems : () => {
      dispatch(loadRuleSet());
    },
    clearAllData:()=>{
      dispatch(clearAllData());
    }
  }
}


export default connect(mapStateToProps,mapDispatchToProps) (Reconciliation);
